module.exports = __webpack_public_path__ + "img/icon_map_ss.082e248c.png";